import {
  AllowedSelfSignUpFieldsSet,
  AllowedSelfSignUpFieldsType,
  AllowedUserFieldsEnum
} from 'shared/accountNameConfig'
import { UserValidationFields } from 'shared/entities-validator/user-fields-validators'
import { InputControlProps } from 'formik-chakra-ui/dist/input-control'
import { MobileNumberSignUpField } from 'front-end/src/pages/auth/self-signup/fields/MobileNumberSignUpField'
import React from 'react'
import { SelfSignupFormFieldsContextType } from 'front-end/src/pages/auth/self-signup/SelfSignupFormFieldsContext'
import { LoginContextUserType } from 'front-end/src/pages/auth/login/LoginContext'

export const getSortedUserFields = (
  fields?: AllowedUserFieldsEnum[] | null
): AllowedUserFieldsEnum[] => {
  if (!fields) {
    return []
  }

  /* must exist, otherwise we need to show an error to user*/

  // get index of field as they appear at admin dashboard
  const fieldsOrder = Object.values(AllowedUserFieldsEnum).reduce(
    (acc, f, i) => {
      acc[f] = i
      return acc
    },
    {} as Record<AllowedUserFieldsEnum, number>
  )
  // sort by that index
  return [...fields].sort((a, b) => fieldsOrder[a] - fieldsOrder[b])
}

export const getUserFieldsProps = (
  field: UserValidationFields,
  translatedLabels: Record<AllowedUserFieldsEnum, string>
): InputControlProps => {
  const inputProps: InputControlProps = {
    name: field,
    label: translatedLabels[field]
  }
  if (field === AllowedUserFieldsEnum.EMAIL) {
    inputProps.inputProps = {
      ...inputProps.inputProps,
      // needed for 1password/etc. autocomplete
      autoComplete: 'email'
    }
    inputProps.placeholder = 'you@email.com'
  } else if (field === AllowedUserFieldsEnum.ACCOUNT_NAME) {
    inputProps.inputProps = {
      ...inputProps.inputProps,
      // needed for 1password/etc. autocomplete
      autoComplete: 'username'
    }
  }
  return inputProps
}

export const FIELDS_CUSTOM_INPUT = {
  [AllowedUserFieldsEnum.PHONE_NUMBER]: (props) => (
    <MobileNumberSignUpField {...props} />
  )
}

export const reduceSelfSignUpFields = (
  data: LoginContextUserType,
  fields: SelfSignupFormFieldsContextType['fields']
) => {
  if (!data) {
    return []
  }
  return fields
    .filter((row) =>
      AllowedSelfSignUpFieldsSet.has(
        row as string as AllowedSelfSignUpFieldsType
      )
    )
    .reduce((obj, item) => {
      if (data[item]) {
        obj[item] = data[item]
      }
      return obj
    }, {})
}

export const getUrlForReceptionist = (): string => {
  const hostParts = location.host.split('.')
  hostParts.shift()
  return `${location.protocol}//app.${hostParts.join('.')}`
}
